import {
  FArrangementTypesEnum,
  FCompositionTypesEnum,
  FEnsembleTypesEnum,
} from '../types/index.js';

/**
 * Create a fcomposition id from a type and an id.
 *
 * The first 1 bit is the type of composition, the next 7 bits are the id of the composition,
 * resulting in a 8 unsigned bit integer for the representation with 128 possible values per type.
 *
 * Payload is a 24 bit unsigned integer that can be used to store additional information.
 *
 * (payload 24bit) | (type 1bit) | (subtype 7bit)
 */
export const encodeFCompositionId = <
  TType extends FCompositionTypesEnum,
  TSType extends TType extends FCompositionTypesEnum.FEnsemble
    ? FEnsembleTypesEnum
    : FArrangementTypesEnum
>(
  type: TType,
  subtype: TSType,
  payload: number = 0
) => ((payload << 8) & 0xffffff) | ((subtype << 1) & 0x7f) | (type & 0x01);
